export const contactsHeaderTitles = {
  title: 'Contactes',
  orderBtn: 'Encarregar',
};
